import React, {Component} from "react";
import styled from "react-emotion";

const InformationCard = styled("div")`
  border: 1px solid lightgrey;
  border-radius: 5px;
  padding: 5px 5px 5px 10px;
  min-height: 30px;
  margin: 5px;
`;

interface ITextEmotionModelOutputState {
    result: any;
    errorMessage: string;
}

class TextEmotionModelOutput extends Component<{}, ITextEmotionModelOutputState> {
    public constructor(props: {}) {
        super(props);

        this.state = {
            result: [],
            errorMessage: ""
        };
    }

    public capitalizeName = (name: string) => {
        return name[0].toUpperCase() + name.substr(1);
    };

    public processResponse = (response: any) => {
        if (response && response.scores && response.scores.length) {
            this.setState({
                result: response.scores.sort((a: any, b: any) => {
                    return a.value < b.value ? 1 : -1;
                })
            });
        } else {
            this.setState({
                errorMessage: "Couldn't process text."
            });
        }
    };

    public render() {
        return <React.Fragment>
            {
                this.state.result.length ? <div>
                    <InformationCard>
                        {
                            this.state.result.map((score: any) => {
                                return <p key={score.name}>{this.capitalizeName(score.name)}{" - "}{score.value}</p>
                            })
                        }
                    </InformationCard>
                </div> : <></>
            }
            {
                this.state.errorMessage ? <InformationCard>{this.state.errorMessage}</InformationCard> : <></>
            }
        </React.Fragment>;
    }
}

export default TextEmotionModelOutput;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/CrossProvider/output/TextEmotion/TextEmotionModelOutput.tsx